import catalogJson from 'data/bankFieldCatalog.json'

export interface BankFieldDefinition {
    name: string
    label: string
    required: boolean
    type: 'text' | 'select'
    options: Array<{
        value: string
        label: string
    }>
}

export type BankTransferMethod = 'wire' | 'ach'

const catalog = catalogJson as Record<
    string,
    BankFieldDefinition[]
>

export const getBankFields = (
    country: string,
    method: BankTransferMethod,
    beneficiaryType: string
): BankFieldDefinition[] | null => {
    if (!country || !beneficiaryType) {
        return null
    }

    const transferType = method === 'ach' ? 'EFT' : 'WIRE'

    const key = [
        country.trim().toUpperCase(),
        transferType,
        'USD',
        beneficiaryType.trim().toUpperCase()
    ].join('|')

    return Object.prototype.hasOwnProperty.call(catalog, key)
        ? catalog[key]
        : null
}
